import { BlogController } from './_controller'

export function initBlogPage() {
  const blogContainer = document.querySelector<HTMLElement>('[data-blog-page]')

  if (blogContainer) {
    new BlogController(blogContainer)
  }
}
